import React from 'react';
import PropTypes from 'prop-types';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import clsx from 'clsx';

import './dropdown-button.scss';

const DEFAULT_CLASSES = ['button--unstyled', 'no-padding'];

/**
 * @description: AP Dropdown button
 * @param {*}
 * @return {*}
 */
const DropdownButton = ({
  isOpen,
  onClick,
  showIcon = false,
  className = '',
  buttonName = null,
  setRef = null, // Used to stop click propagation in parent element.
  disabled = false,
  children,
  ...restProps
}) => {
  const distinctButtonName = buttonName ? `button--${buttonName}` : '';

  const renderArrow = () => {
    return isOpen ? <MdKeyboardArrowUp size={14} /> : <MdKeyboardArrowDown size={14} />;
  };

  return (
    <button
      ref={setRef}
      className={clsx(
        'ap-dropdown__trigger',
        className === '' ? DEFAULT_CLASSES : className,
        showIcon && 'has-icon',
        !!buttonName && distinctButtonName,
      )}
      onClick={onClick}
      disabled={disabled}
      {...restProps}
      aria-expanded={isOpen}
    >
      <span className="ap-dropdown__trigger-content">
        {children}
        {showIcon && !disabled ? (
          renderArrow()
        ) : null }
      </span>
    </button>
  );
};

DropdownButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  buttonName: PropTypes.string,
  setRef: PropTypes.func,
};

export default DropdownButton;
